<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }">
        <div class="pop_container">
            <div class="close_icon">
                <img src="@/assets/close_bai.png" alt="" @click="close">
            </div>
            <div class="title">{{ $t("common.activityTitle") }}</div>
            <div class="content">
                <div v-for="item in content" :key="item">
                    {{ item }}
                </div>
            </div>
            <div class="btn_container">
                <MainButton :title="$t('common.ok')" :onclick="close" :activeStatus="true" />
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import MainButton from '../../components/common/mainButton.vue'

const show = ref(false)
const content = ref([])
const open = (data: any) => {
    show.value = true
    content.value = data
}
const close = () => {
    show.value = false
}
defineExpose({
    open,
})

</script>
<style scoped>
.pop_container {
    background: #2d323d;
    border: 1px solid #b3a5c7;
    padding: 15px;
    border-radius: 20px;
    width: 80%;
}

.content {
    padding: 5px 15px;
    font-size: 14px;
    color: #ffffffa6;
    line-height: 24px;
}

.content span {
    color: #FFEE00;
}

.van-overlay {
    background-color: #0000009c
}

.close_icon {
    display: flex;
    justify-content: right;
}

.close_icon img {
    width: 25px;
    opacity: 0.5;
}

.title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 5px;
}

.btn_container {
    padding: 15px 35px;
}
</style>